import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { NetworkView } from "./network";

const NetworkDiagPanel: Component = () => <NetworkView title="Diagnostic réseau" view="diag" />;

registerPanel("network-diag", NetworkDiagPanel);
export default NetworkDiagPanel;
